import 'css-chunksrc/client/common/quickCreationMenuWrapper/styles.scss';export default {
  "quickCreationMenuWrapper": "_quickCreationMenuWrapper_1sy1p_1",
  "wrapper": "_wrapper_1sy1p_5",
  "elementCreationForm": "_elementCreationForm_1sy1p_11",
  "actions": "_actions_1sy1p_15",
  "action": "_action_1sy1p_15",
  "addMenu": "_addMenu_1sy1p_34",
  "addIcon": "_addIcon_1sy1p_51",
  "formVisible": "_formVisible_1sy1p_58",
  "thick": "_thick_1sy1p_66"
};